import { FluentProvider } from "@/dependencies";
import { Text, TextProps } from "@fluentui/react-components";

interface TextCustomProps {
  rcName?: string;
  theme?: string;
}

const TextCustom = (props: TextCustomProps & TextProps) => {
  return props.theme ? (
    <FluentProvider theme={props.theme}>
      <Text {...props} />
    </FluentProvider>
  ) : (
    <Text {...props} />
  );
};

export default TextCustom;
